export default {
  title: 'Domínios',
  description: 'Organize as áreas funcionais de cada serviço e defina quais funcionalidades pertencem a cada uma delas.',
  labels: {
    new: 'Novo Domínio',
  },
  fields: {
    name: 'Nome do Domínio',
  },
  groups: {
    data: 'Dados do domínio',
    modules: 'Módulos vinculados',
  },
  modules: {
    title: 'Módulos por domínios',
    description: 'Defina quais funcionalidades pertencem a esta área e se cada uma aparece no catálogo ou no menu.',
    labels: {
      new: 'Novo Vínculo',
    },
    fields: {
      name: 'Módulo',
      show_in_catalog: 'Exibir no catálogo',
      show_in_menu: 'Exibir no menu',
      menu_order: 'Ordem no menu',
      catalog_order: 'Ordem no catálogo',
    },
    errors: {
      duplicateCompositeKey: 'Já existe um vínculo para este módulo e domínio.'
    }
  }
};
